import Box from '@mui/material/Box'
import Fade from '@mui/material/Fade'
import Popover from '@mui/material/Popover'
import { SxProps, Theme } from '@mui/material/styles'
import React, { useState } from 'react'

interface IProps {
    children: JSX.Element | JSX.Element[]
    content: JSX.Element
    sx?: SxProps<Theme>
    showOnHover?: boolean
    showOnClick?: boolean
}

const PopoverWithContent: React.FC<IProps> = (props) => {
    const { children, content, sx = {}, showOnHover = false, showOnClick = true } = props

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
    const [clicked, setClicked] = useState<boolean>(false)

    const open = Boolean(anchorEl)
    const id = open ? `daily-puzzle-calendar-popover` : undefined

    const onShow = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const onHide = () => {
        setAnchorEl(null)
    }

    const onShowClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        if (showOnClick) {
            setClicked(true)
            onShow(event)
        }
    }

    const onShowHover = (event: React.MouseEvent<HTMLElement>) => {
        if (!clicked && showOnHover) {
            onShow(event)
        }
    }

    const onHideHover = () => {
        if (!clicked && showOnHover) {
            onHide()
        }
    }

    const onHideClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        if (showOnClick) {
            setClicked(false)
            onHide()
        }
    }

    return (
        <React.Fragment>
            <Box
                aria-owns={id}
                aria-describedby={id}
                aria-haspopup="true"
                onClick={onShowClick}
                onMouseEnter={onShowHover}
                onMouseLeave={onHideHover}
                sx={{ ...sx, cursor: showOnClick ? 'pointer' : 'auto' }}
            >
                {children}
            </Box>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={onHideClick}
                onClick={(event) => {
                    event.stopPropagation()
                }}
                TransitionComponent={Fade}
                anchorOrigin={{
                    vertical: -40,
                    horizontal: -45,
                }}
                slotProps={{
                    paper: {
                        sx: {
                            border: `1px solid`,
                            borderColor: 'secondary.dark',
                            backgroundColor: 'background.default',
                            borderRadius: '6px',
                            overflowY: 'hidden',
                        },
                    },
                }}
                sx={{
                    pointerEvents: clicked ? 'auto' : 'none',
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'transparent',
                    },
                }}
                disableRestoreFocus
            >
                {content}
            </Popover>
        </React.Fragment>
    )
}

export default PopoverWithContent
